<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle1"><a id="page_ix"></a><a id="contents"></a>Contents</h1>
<p class="toc"><a href="#/07_introduction#intro">Introduction</a></p>
<p class="toc"><a href="#/08_part01#p01"><b>Part I: Preparing Your Organization for Perpetual Growth</b></a></p>
<p class="toc"><a href="#/09_chapter01#c01">Chapter 1 <br/><i>Debunking the Myth: Talent Will Grow Where It's Planted</i></a></p>
<p class="toc"><a href="#/10_chapter02#c02">Chapter 2 <br/><i>Surveying the Terrain: The Five Essential Elements <br/>Needed for Evergreen Talent</i></a></p>
<p class="toc"><span href="#/11_chapter03#c03" title="Link target outside of Sample">Chapter 3 <br/><i>Tilling the Organization: Preparing Your Environment for a <br/>New Approach to Talent Cultivation</i></span></p>
<p class="toc"><a id="page_x"></a><span href="#/12_part02#p02" title="Link target outside of Sample"><b>Part II: Seeding Your Organization</b></span></p>
<p class="toc"><span href="#/13_chapter04#c04" title="Link target outside of Sample">Chapter 4 <br/><i>A Matter of Climate: Identifying the Right <br/>Saplings for Your Environment</i></span></p>
<p class="toc"><span href="#/14_chapter05#c05" title="Link target outside of Sample">Chapter 5 <br/><i>Abundant Hiring: Sustainable Hiring Practices <br/>for Optimal Growth</i></span></p>
<p class="toc"><span href="#/15_chapter06#c06" title="Link target outside of Sample">Chapter 6 <br/><i>Corporate Regeneration: Reinvigorating Dormant Workers</i></span></p>
<p class="toc"><span href="#/16_part03#p03" title="Link target outside of Sample"><b>Part III: Cultivating Your Workforce</b></span></p>
<p class="toc"><span href="#/17_chapter07#c07" title="Link target outside of Sample">Chapter 7 <br/><i>The Need to Weed: Making Room for New Growth to Flourish</i></span></p>
<p class="toc"><span href="#/18_chapter08#c08" title="Link target outside of Sample">Chapter 8 <br/><i>Growing Talent from Seedling to Redwood</i></span></p>
<p class="toc"><span href="#/19_chapter09#c09" title="Link target outside of Sample">Chapter 9 <br/><i>Replenishing Talent: Ensuring Your New Crop <br/>of Talent Takes Root</i></span></p>
<p class="toc"><a id="page_xi"></a><span href="#/20_chapter10#c10" title="Link target outside of Sample">Chapter 10 <br/><i>The Canopy of Mature Workers: Why Evergreen Employees Are <br/>Vital to Your Company's Survival</i></span></p>
<p class="toc"><span href="#/21_part04#p04" title="Link target outside of Sample"><b>Part IV: Creating and Sustaining Growth</b></span></p>
<p class="toc"><span href="#/22_chapter11#c11" title="Link target outside of Sample">Chapter 11 <br/><i>Nurturing Employees to Greatness</i></span></p>
<p class="toc"><span href="#/23_chapter12#c12" title="Link target outside of Sample">Chapter 12 <br/><i>Corporate Pruning: Getting Rid of Dead Wood to <br/>Make Room for New Growth</i></span></p>
<p class="toc"><span href="#/24_conclusion#con" title="Link target outside of Sample">Conclusion <br/><i>Some Parting Words</i></span></p>
<p class="toc"><span href="#/25_appendix#app" title="Link target outside of Sample">Appendix</span></p>
<p class="toc"><span href="#/26_notes#notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/27_index#index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_contents.vue?6e9d9504